import { WINDOW } from "constants/environment"
import { scrollToElementId } from "AtomicUtils/scroll"

// Functions that can be used in urlHandler
// new urlHandler(URL);
// setParam(key, value, changeURLOfThePage)
// removeParam(key, changeURLOfThePage)
// newTab()

export default class urlHandler {
  constructor(fullUrl) {
    this.href = fullUrl
    this.hrefWithoutSearchParams = ""
    this.searchParams = ""
    this.details = {}
    this.query = {}

    this.parseUrl()
  }

  parseUrl = () => {
    this.setHrefWithoutSearchParams()
    this.setSeachParams()
    this.setDetails()
    this.setSearchParamsQuery()
  }

  getHref = () => {
    return this.href
  }

  setHrefWithoutSearchParams = () => {
    this.hrefWithoutSearchParams = this.href.split("?")[0]
  }

  setDetails = () => {
    const parsed = this.href.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
    if (parsed){
      this.details = {
          protocol: parsed[1],
          host: parsed[2],
          hostname: parsed[3],
          port: parsed[4],
          pathname: parsed[5],
          search: parsed[6],
          hash: parsed[7]
      }
    }
  }

  getPathname = () => {
    return this.details.pathname
  }

  getHrefWithoutSearchParams = () => {
    return this.hrefWithoutSearchParams
  }

  setSeachParams = () => {
    this.searchParams = this.href.split("?")[1]
  }

  getSeachParams = () => {
    return this.searchParams
  }

  setSearchParamsQuery = () => {
    const query = {}
    if (this.searchParams){
      const pairs = (this.searchParams[0] === "?" ? this.searchParams.substr(1) : this.searchParams).split("&")
      for (let i = 0; i < pairs.length; i += 1) {
        const pair = pairs[i].split("=")
        const key = decodeURIComponent(pair[0])
        if (query[key]) {
          if (!Array.isArray(query[key])) {
            query[key] = [query[key]]
          }
          query[key].push(decodeURIComponent(pair[1] || ""))
        } else {
          query[key] = decodeURIComponent(pair[1] || "")
        }
      }
    }
    this.query = query
  }

  getSearchParamsQuery = () => {
    return this.query
  }

  getParam = (key) => {
    return this.query[key]
  }

  buildNewUrl = (queries) => {
    let newSearchParams = ""
    Object.keys(queries).forEach((key)=>{
      if (key && key !== null && queries[key] !== null) {
        if (newSearchParams !== "") {
          newSearchParams += `&${key}=${queries[key]}`
        } else {
          newSearchParams = `?${key}=${queries[key]}`
        }
      }
    })
    this.href = `${this.hrefWithoutSearchParams}${newSearchParams !== "" ? newSearchParams : ""}`
    this.parseUrl()
    return this.href
  }

  setParam = (key, value, changeURLOfThePage) => {
    const newKey = encodeURIComponent(key)
    const newValue = encodeURIComponent(value)
    const queries = this.query

    queries[newKey] = newValue
    this.href = this.buildNewUrl(queries)

    if (changeURLOfThePage) WINDOW.history.pushState(null, null, this.href)

    return this.href
  }

  removeParam = (key, changeURLOfThePage) => {
    const newKey = encodeURIComponent(key)
    const queries = this.query

    if (queries[newKey]) {
      delete queries[newKey]
    }

    this.href = this.buildNewUrl(queries)

    if (changeURLOfThePage) WINDOW.history.pushState(null, null, this.href)

    return this.href
  }

  newTab = (addOrigin = false) => {
    let newHref = this.href
    if (addOrigin){
      newHref = WINDOW.location.origin + newHref
    }
    WINDOW.open(newHref)
  }

  redirect = (addOrigin = false) => {
    let newHref = this.href
    if (addOrigin){
      newHref = WINDOW.location.origin + newHref
    } else if (newHref.replace(WINDOW.location.pathname, '').slice(0, 1) === "#") {
      scrollToElementId(newHref.split("#")[1])
    } else if (newHref.replace(WINDOW.location.pathname, '').slice(0, 2) === "/#") {
      scrollToElementId(newHref.split("#")[1])
      this.setHash(newHref.split("#")[1])
      return
    }
    WINDOW.location = newHref
  }

  getHash = () => WINDOW.location.hash.slice(1)

  setHash = (hash) => WINDOW.location.hash = hash
}



// WEBPACK FOOTER //
// ./src/AtomicUtils/urlHandler.js